import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { WinnerThumbnail } from './WinnerThumbnail';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import { resourcePath } from '@gameday/utils/resource-path';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';

import useTracking from '@gameday/utils/hooks/useTracking';

import { WinnerDescriptionWrapper, WinnerName, WinnerStats, WinnerWrapper } from '../PlayerOfTheGame.style';

import { getLanguagePath } from '@gameday/utils/languageHelpers';

const Winner = (props) => {
    const {
        winner,
        deviceInteraction,
        language = 'en',
        isLoadingStories,
        trackingProps
    } = props;

    const {
        story,
        boxscoreName,
        statLine,
        hasStory,
        feedId,
        WPA
    } = winner;
    const translate = useTranslate();
    const sign = WPA > 0 ? '+' : '';
    const wpaStatLine = `\n${sign}${WPA}% ${translate('label_potg_wpa', 'WPA')}`;

    const playerPageUrl = resourcePath.get('mlbPlayerPage', { pid: feedId, languagePath: getLanguagePath(language) });
    const Tracking = useTracking();
    const handleStoryUrl = useCallback(
        (e) => {
            const { componentName } = trackingProps;
            const cfg = {
                componentName: componentName.concat(['Player Story']),
                text: e?.target?.innerText,
                activity: 'Link Click'
            };
            Tracking.track.track_click(cfg);

            if (deviceInteraction.webview({ url: story })) {
                e.preventDefault();
            }
        },
        [deviceInteraction, trackingProps]
    );
    const handlePlayerPage = useCallback((e) => {
        const { componentName } = trackingProps;
        const cfg = {
            componentName: componentName.concat(['Player of the Game Winner']),
            text: e?.target?.innerText,
            activity: 'Link Click'
        };
        Tracking.track.track_click(cfg);

        if (deviceInteraction.playercard({ title: 'Player Card', url: playerPageUrl, pid: feedId })) {
            e.preventDefault();
            return false;
        }
    }, [deviceInteraction, playerPageUrl, feedId, trackingProps]);

    const linkHandlers = useMemo(() => {
        const onClickHandler = hasStory ? handleStoryUrl : handlePlayerPage;
        return { onClick: onClickHandler };
    },
    [handleStoryUrl, handlePlayerPage, hasStory]
    );

    const playerLinkUrl = hasStory ? story : playerPageUrl;

    return (
        <WinnerWrapper>
            <Link
                url={playerLinkUrl}
                target={'_blank'}
                handlers={linkHandlers}
            >
                <WinnerThumbnail
                    winner={winner}
                    isLoadingStories={isLoadingStories}
                />
            </Link>
            <WinnerDescriptionWrapper>
                <WinnerName>
                    {boxscoreName}
                </WinnerName>
                <WinnerStats>
                    {statLine[language]}
                    {wpaStatLine}
                </WinnerStats>
            </WinnerDescriptionWrapper>
        </WinnerWrapper>
    );
};

Winner.propTypes = {
    winner: PropTypes.object,
    voteLink: PropTypes.string,
    deviceInteraction: PropTypes.object,
    componentName: PropTypes.string,
    language: PropTypes.string,
    isLoadingStories: PropTypes.bool,
    trackingProps: PropTypes.object
};

export default Winner;
